import { GridColDef } from '@mui/x-data-grid-pro';

import { IAccount, IMeter } from 'common/src/types/interfaces';

import addTriStateColumnProps from './addTriStateColumnProps';

const getAccountTypeLabel = (row: IAccount): 'Master' | 'Sub-Account' | '-' =>
  row?.isMaster ? 'Master' : row?.isSub ? 'Sub-Account' : '-';

const getMeterTypeLabel = (row: IMeter): 'Master' | 'Sub-Meter' | '-' =>
  row?.isMaster ? 'Master' : row?.masterMeterId ? 'Sub-Meter' : '-';

export const masterSubAccountColumn: GridColDef = {
  field: 'masterSubAccount',
  headerName: 'Master/Sub-Account',
  ...addTriStateColumnProps({
    getLabel: (row: IAccount) => getAccountTypeLabel(row),
    valueOptions: ['-', 'Sub-Account', 'Master'],
  }),
};

export const masterSubMeterColumn: GridColDef = {
  field: 'masterSubMeter',
  headerName: 'Master/Sub-Meter',
  ...addTriStateColumnProps({
    getLabel: (row: IMeter) => getMeterTypeLabel(row),
    valueOptions: ['-', 'Sub-Meter', 'Master'],
  }),
};
